import { CreateLoginTokenRequest } from '../types/types'
import { CreateAuthenticationTokenForLoginTokenResponse } from './CreateAuthenticationTokenForLoginTokenResponse'

export enum PreferredLoginMethod {
  MAIL = 'mail',
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  NONE = 'none'
}

export type SignInState = {
  data: {
    email: string
    code?: string
    loginToken?: CreateLoginTokenRequest
    createAuthenticationTokenForLoginTokenResponse?: CreateAuthenticationTokenForLoginTokenResponse
  }
  preferredLoginMethod: PreferredLoginMethod
  step: SignInSteps
}

export type SignInViewProps = {
  disableEditEmail?: boolean
  /** Set when the user arrived via an org invite link. Drives invite-mode copy
   *  (welcome heading, locked-email helper, "Continue" button) on the landing
   *  step. The org name (if available) is shown in the heading. */
  inviteMode?: boolean
  inviteOrganizationName?: string
  /** Translated backend rejection (e.g. invitation-only login refusal) shown on the email form. */
  serverError?: string
  isLoading: boolean
  signInState: SignInState
  onPressContinue: (state: SignInState) => Promise<unknown>
  onTakeMeBack: () => unknown
  onClickBack: () => unknown
  onLoginWithGoogle?: () => void
  onLoginWithMicrosoft?: () => void
  onLoginWithApple?: () => void
}

export enum SignInSteps {
  LANDING = 'LANDING',
  ENTER_CODE = 'ENTER_CODE',
  DISABLED = 'DISABLED',
  ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIALS = 'ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIALS'
}
